import { useState, useEffect, useMemo } from 'react';

import useScrollStore from '../../../../common/store/useScrollStore';
import { getSections, getThresholds } from '../../../Main/utils';

const useSection = () => {
  const [section, setSection] = useState(0);
  const thresholds = useMemo(() => getThresholds(), []);

  useEffect(() => useScrollStore.subscribe(state => {
    const _section = getSections(-state.position, thresholds);
    setSection(_section);
  }), [thresholds]);

  return section;
}

export default useSection;